import { render } from "./SupportQuickEntry.vue?vue&type=template&id=b3f670a6&scoped=true"
import script from "./SupportQuickEntry.vue?vue&type=script&lang=js"
export * from "./SupportQuickEntry.vue?vue&type=script&lang=js"

import "./SupportQuickEntry.vue?vue&type=style&index=0&id=b3f670a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3f670a6"]])

export default __exports__